<template>
    <div>
        <vsmallheader></vsmallheader>

        <div>   
            <div class="metter">
                
                <div style="margin-top:20px;padding-bottom:10px;display:flex;font-size:16px">
                    <div style="font-size:14px;color:#888;display:flex;align-items: center">
                <img src="@/assets/resource/adresst.png" style="width:15px;height:15px;margin-right:5px" />
                当前位置：
                </div>
                <span  style="cursor: pointer;font-size: 14px;" @click="retrun">首页</span> / <span style="cursor: pointer;font-size: 14px;" @click="retrun">{{dongtai}}</span> <span style="font-size: 14px;">/ 详情 / {{form.title}}</span></div>
                <div class="mettera">
                    <!-- <el-button   icon="el-icon-arrow-left" @click="retrun"></el-button> -->
                    <h2>{{form.title}}</h2>
                    <div class="nav">
                        <div>浏览量：{{form.readCount}}</div>
                        <div class="shu">|</div>
                        <div>发布时间：{{form.createTime}}</div>
                    </div>
                    <div class="aaa"></div>
                    <p v-html="htmlcontents" class="ppp"></p>
                </div>
            </div>
        </div>
        <!-- <linecom></linecom> -->
    </div>
</template>
<script>
import * as teacher from '@/api/teacher/teacherInfo.js'
import vsmallheader from '@/views/smallHeader/index'
import linecom from '@/components/linecom/index';
export default {
    components:{
        vsmallheader,linecom
    },
    data(){
        return{
            dongtai:'',
            id:this.$route.query.id,
            form:'',
            htmlcontents:'',
        }
    },
    created(){
        // console.log(this.id)
        // console.log(this.$route.query.CateId)
        this.getmetter()
        if(this.$route.query.type==1){
            this.dongtai=' 心得'
        }else{
            this.dongtai='教案'
        }
    },
    methods:{
        getmetter(){
            teacher.TeacherBlogsGet({id:this.id}).then(res=>{
                this.form=res.result
                this.htmlcontents=this.form.contents.replace('border="0"','border="1"')
                // console.log(this.htmlcontents)
            })
        },
        retrun(){
            this.$router.go(-1)
        },
        retrunhome(){
            this.$router.push('/diaoa')
        }
    }

}
</script>
<style scoped>
.metter{
    width: 1200px;
    
    /* background-color:; */
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
    
}
.mettera{
    width: 1200px;
    /* background-color:; */
    min-height: 720px;
    margin: 0 auto;
    box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(242, 242, 242, 1);
    border-radius: 5px;
    padding-bottom: 30px;
}
h2{
    text-align: center;
    line-height: 70px;
}
.nav{
    margin-left: 450px;
    width: 500px;
    display: flex;
        color: #7F7F7F;
}
.shu{
    margin: 0px 10px;
}
.aaa{
    margin-top: 10px;
    height: 1px;
    background-image: linear-gradient(to right, #ccc 0%, #ccc 50%, transparent 50%);
    background-size: 20px 1px;
    background-repeat: repeat-x;
    margin-bottom: 20px;
    
}
p{
    padding:0px 100px;
    font-size: 18px;
    line-height: 30px;
    text-indent:2em
}

table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
table td,
table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
}
table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}
</style>